import App from '@/main';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        //LOADING
        loading: false,

        //TOAST
        option: null,
        
        //DIALOG
        dialog: false,
        routePath: '',
        notificationOption: ''
    },
    getters: {
        //LOADING
        loading: state => state.loading,

        //DIALOG
        dialog: state => state.dialog
    },
    mutations: {
        //LOADING 
        [type.SET_LOADING]: state => {
            state.loading = true
        },
        [type.REMOVE_LOADING]: state => {
            state.loading = false;
        },

        [type.SET_ROUTE]: (state, payload) => {
            state.routePath = payload
            App.$router.push(payload).catch(err => {})
        },

        [type.SET_NOTIFICATION]: (state, payload) => {
            state.notificationOption = payload
            App.$message({
                showClose: true,
                message: payload.message,
                type: payload.type
            });
        },

        //LOADING
        [type.SET_MESSAGE]: (state, payload) => {
            state.option = payload
            App.$toast.open({
                type: payload.type,
                message: payload.message
            })
        },

        //DIALOG
        [type.OPEN_DIALOG]: state => state.dialog = true,
        [type.CLOSE_DIALOG]: state => state.dialog = false,
    },

    actions: {
        [type.OPEN_DIALOG]: ({commit}) => {
            commit(type.OPEN_DIALOG)
        },
        [type.CLOSE_DIALOG]: ({commit}) => {
            commit(type.CLOSE_DIALOG)
        },
    }
}